import styled from "styled-components";

export const RecordActionGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  .iconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    line-height: 1.5;
    padding: 4px;
    border-radius: 4px;
    height: max-content;
    cursor: pointer;

    &.iconInBoat {
      border-bottom: 1px solid #1249bf;
    }

    svg {
      width: 16px;
      height: 16px;
      font-size: 16px;
    }

    svg.fileUploadCardIcon {
      width: 22px;
      height: 22px;
    }

    &:hover {
      background-color: #2060ea;
      color: white;

      svg path {
        fill: white;
      }

      svg.fileUploadCardIcon path {
        fill: none;
        stroke: white;
      }
    }
  }

  .actionDivider {
    width: 1px;
    height: 20px;
    margin: 0 2px;
    background: #d5deea;
    flex-shrink: 0;
  }

  &.summaryActions {
    gap: 6px;

    .iconWrapper {
      position: relative;
      width: 34px;
      height: 34px;
      padding: 0;
      border: 1px solid #d5deea;
      border-radius: 6px;
      background: #fff;
      color: #1249bf;

      svg {
        width: 16px;
        height: 16px;
      }

      svg.fileUploadCardIcon {
        width: 20px;
        height: 20px;
      }

      svg path {
        fill: currentColor;
        fill-opacity: 1;
      }

      svg.fileUploadCardIcon path {
        fill: none;
        stroke: currentColor;
        stroke-opacity: 1;
      }

      &:hover {
        background: #f4f7ff;
        border-color: #2060ea;
        color: #1249bf;

        svg path {
          fill: currentColor;
        }

        svg.fileUploadCardIcon path {
          fill: none;
          stroke: currentColor;
        }
      }
    }

    .taskBadge {
      position: absolute;
      top: -5px;
      right: -5px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 8px;
      background: #1249bf;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      line-height: 16px;
      text-align: center;
    }
  }
`;
